import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { Stack } from "@mui/system";

function GenreFilterPills({ setGenreFilters, genreFilters }) {
  const handleChange = (event, newGenre) => {
    console.log("newGenre", newGenre, event.target.value);
    if (event.target.value === "All") {
      setGenreFilters(["All"]);
    } else if (newGenre.includes("All")) {
      newGenre.splice(newGenre.indexOf("All"), 1);
      setGenreFilters(newGenre);
    } else {
      setGenreFilters(newGenre);
    }
  };
  return (
    <ToggleButtonGroup

      value={genreFilters}
      onChange={handleChange}
      aria-label="text alignment"
    >
    
      <ToggleButton  value="All" aria-label="All Genres">
        All Genres
      </ToggleButton>
      <ToggleButton value="Education" aria-label="Education">
        Education
      </ToggleButton>
      <ToggleButton value="Sports" aria-label="Sports">
        Sports
      </ToggleButton>
      <ToggleButton value="Comedy" aria-label="Comedy">
        Comedy
      </ToggleButton>
      <ToggleButton value="Lifestyle" aria-label="Lifestyle">
        Lifestyle
      </ToggleButton>

    </ToggleButtonGroup>
  );
}

export default GenreFilterPills;
